import { CheckoutModal } from "@kompare/kompare-ui-library";
import { i18n, useGetTermsAndConditionsForOffer } from "src/common";
import TermsCard from "../cards/termsCard";
import { LoaderSquare } from "../other";
import { useEffect } from "react";

export interface TermsAndConditionsProps {
  open?: boolean;
  title?: string;
  onClose?: () => void;
  offerId?: string;
}

export const TermsAndConditionsModal = ({ offerId, open = false, title = i18n.t('components.modals.termsAndConditionsModal.title'), onClose }: TermsAndConditionsProps) => {
  const { termsAndConditions, loading, refetch } = useGetTermsAndConditionsForOffer(offerId);
  
  useEffect(() => {
    refetch();
  }, [open])
  
  return (
    <CheckoutModal title={title} open={open} onClose={() => onClose && onClose()}>
      {loading && <LoaderSquare overlay={true} />}
      {termsAndConditions && (
        <TermsCard termsAndConditions={termsAndConditions} isModal={true} />
      )}
    </CheckoutModal>
  );
};
